// extracted by mini-css-extract-plugin
export var li = "_ui-2";
export var ol = "_ui-1";
export var ul = "_ui-0";